module.exports = __webpack_public_path__ + "static/img/renovations.b530305.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/renovations.jpg
// module id = bGlz
// module chunks = 0